import {Navigate, Route, Routes, Outlet, useParams, useSearchParams} from 'react-router-dom'
import { DefaultTitle } from '../../../../_metronic/layout/components/header/page-title/DefaultTitle'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import { EmailConfirmation } from '../verification/EmailConfirmation'
import { ResetPassword } from '../verification/ResetPassword'
import { PersonalPublication } from './PersonalPublication'
import { Question } from '../dev/components/Question'
import { PublicationEdit } from './PublicationEdit'
import { PublicationAdd } from './PublicationAdd'
import { Article } from '../share-components/Article'

const PersonalPage = () => {

  var devBreadCrumbs: Array<PageLink> = [
    {
      title: 'ผลงานส่วนตัว',
      path: '/personal_publication',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  const [queryParameters] = useSearchParams()
  
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='publication_detail'
          element={
            <>
              <PageTitle breadcrumbs={devBreadCrumbs}>แก้ไขรายละเอียด</PageTitle>
              <DefaultTitle />
              <Article />
            </>
          }
        />
        <Route
          path='publication_add'
          element={
            <>
              <PageTitle breadcrumbs={devBreadCrumbs}>ผลงานใหม่</PageTitle>
              <DefaultTitle />
              <PublicationAdd />
            </>
          }
        />
        <Route
          path='publication_edit'
          element={
            <>
              <PageTitle breadcrumbs={devBreadCrumbs}>แก้ไขรายละเอียด</PageTitle>
              <DefaultTitle />
              <PublicationEdit />
            </>
          }
        />
        <Route
          path='email_confirm'
          element={
            <>
              <DefaultTitle />
              <EmailConfirmation />
            </>
          }
        />
        <Route
          path='password_reset'
          element={
            <>
              <DefaultTitle />
              <ResetPassword />
            </>
          }
        />
    
        <Route index element={<PersonalPublication />} />
      </Route>
    </Routes>
  )
}

export default PersonalPage
